import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  _UInt___init__impl__l7qpdl2xbmh7to8lpd7 as _UInt___init__impl__l7qpdl,
  UInt__toString_impl_dbgl211hnbf9xsikfsf as UInt__toString_impl_dbgl21,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  _ULong___init__impl__c78o9k4z3cjzifecv6 as _ULong___init__impl__c78o9k,
  ULong__toString_impl_f9au7k3n8y2imw2kac3 as ULong__toString_impl_f9au7k,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import {
  _UByte___init__impl__g9hnc43bwrjlqz9k9id as _UByte___init__impl__g9hnc4,
  UByte__toString_impl_v72jg35cd2pgynmah7 as UByte__toString_impl_v72jg,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import {
  _UShort___init__impl__jigrne3vu9egv7mch1k as _UShort___init__impl__jigrne,
  UShort__toString_impl_edaoee1ut8mfnxr9a1q as UShort__toString_impl_edaoee,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ComposerClass;
function Composer() {
  if (ComposerClass === VOID) {
    class $ {
      constructor(writer) {
        this.u2q_1 = writer;
        this.v2q_1 = true;
      }
      w2q() {
        this.v2q_1 = true;
      }
      x2q() {
        return Unit_instance;
      }
      y2q() {
        this.v2q_1 = false;
      }
      z2q() {
        this.v2q_1 = false;
      }
      a2r() {
        return Unit_instance;
      }
      b2r(v) {
        return this.u2q_1.c2r(v);
      }
      d2r(v) {
        return this.u2q_1.e2r(v);
      }
      f2r(v) {
        return this.u2q_1.e2r(v.toString());
      }
      g2r(v) {
        return this.u2q_1.e2r(v.toString());
      }
      h2r(v) {
        return this.u2q_1.i2r(fromInt(v));
      }
      j2r(v) {
        return this.u2q_1.i2r(fromInt(v));
      }
      k2r(v) {
        return this.u2q_1.i2r(fromInt(v));
      }
      l2r(v) {
        return this.u2q_1.i2r(v);
      }
      m2r(v) {
        return this.u2q_1.e2r(v.toString());
      }
      n2r(value) {
        return this.u2q_1.o2r(value);
      }
    }
    initMetadataForClass($, 'Composer');
    ComposerClass = $;
  }
  return ComposerClass;
}
function Composer_0(sb, json) {
  return json.a2m_1.r2n_1 ? new (ComposerWithPrettyPrint())(sb, json) : new (Composer())(sb);
}
var ComposerForUnsignedNumbersClass;
function ComposerForUnsignedNumbers() {
  if (ComposerForUnsignedNumbersClass === VOID) {
    class $ extends Composer() {
      constructor(writer, forceQuoting) {
        super(writer);
        this.r2r_1 = forceQuoting;
      }
      k2r(v) {
        if (this.r2r_1) {
          // Inline function 'kotlin.toUInt' call
          var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
          this.n2r(UInt__toString_impl_dbgl21(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toUInt' call
          var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
          this.d2r(UInt__toString_impl_dbgl21(tmp$ret$1));
        }
      }
      l2r(v) {
        if (this.r2r_1) {
          // Inline function 'kotlin.toULong' call
          var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
          this.n2r(ULong__toString_impl_f9au7k(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toULong' call
          var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
          this.d2r(ULong__toString_impl_f9au7k(tmp$ret$1));
        }
      }
      h2r(v) {
        if (this.r2r_1) {
          // Inline function 'kotlin.toUByte' call
          var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
          this.n2r(UByte__toString_impl_v72jg(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toUByte' call
          var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
          this.d2r(UByte__toString_impl_v72jg(tmp$ret$1));
        }
      }
      j2r(v) {
        if (this.r2r_1) {
          // Inline function 'kotlin.toUShort' call
          var tmp$ret$0 = _UShort___init__impl__jigrne(v);
          this.n2r(UShort__toString_impl_edaoee(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toUShort' call
          var tmp$ret$1 = _UShort___init__impl__jigrne(v);
          this.d2r(UShort__toString_impl_edaoee(tmp$ret$1));
        }
      }
    }
    initMetadataForClass($, 'ComposerForUnsignedNumbers');
    ComposerForUnsignedNumbersClass = $;
  }
  return ComposerForUnsignedNumbersClass;
}
var ComposerForUnquotedLiteralsClass;
function ComposerForUnquotedLiterals() {
  if (ComposerForUnquotedLiteralsClass === VOID) {
    class $ extends Composer() {
      constructor(writer, forceQuoting) {
        super(writer);
        this.u2r_1 = forceQuoting;
      }
      n2r(value) {
        if (this.u2r_1) {
          super.n2r(value);
        } else {
          super.d2r(value);
        }
      }
    }
    initMetadataForClass($, 'ComposerForUnquotedLiterals');
    ComposerForUnquotedLiteralsClass = $;
  }
  return ComposerForUnquotedLiteralsClass;
}
var ComposerWithPrettyPrintClass;
function ComposerWithPrettyPrint() {
  if (ComposerWithPrettyPrintClass === VOID) {
    class $ extends Composer() {
      constructor(writer, json) {
        super(writer);
        this.x2r_1 = json;
        this.y2r_1 = 0;
      }
      w2q() {
        this.v2q_1 = true;
        this.y2r_1 = this.y2r_1 + 1 | 0;
      }
      x2q() {
        this.y2r_1 = this.y2r_1 - 1 | 0;
      }
      y2q() {
        this.v2q_1 = false;
        this.d2r('\n');
        // Inline function 'kotlin.repeat' call
        var times = this.y2r_1;
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.d2r(this.x2r_1.a2m_1.t2n_1);
          }
           while (inductionVariable < times);
      }
      z2q() {
        if (this.v2q_1)
          this.v2q_1 = false;
        else {
          this.y2q();
        }
      }
      a2r() {
        this.b2r(_Char___init__impl__6a9atx(32));
      }
    }
    initMetadataForClass($, 'ComposerWithPrettyPrint');
    ComposerWithPrettyPrintClass = $;
  }
  return ComposerWithPrettyPrintClass;
}
//region block: exports
export {
  ComposerForUnquotedLiterals as ComposerForUnquotedLiterals3v0rwxdudtla9,
  ComposerForUnsignedNumbers as ComposerForUnsignedNumbers2h1dv6l9z3aef,
  Composer_0 as Composer1pt8hwk95abxi,
};
//endregion

//# sourceMappingURL=Composers.mjs.map
